<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('orgChartStructure.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{ $t('orgChartStructure.company') }}
              </label>
              <div>
                <ts-select
                  v-model="model.company_id"
                  :options="
                    companies.map(company => ({
                      value: company.company_id,
                      text: company.company_name_en
                    }))
                  "
                  :class="{ 'is-invalid': errors.has('company_id') }"
                  autofocus
                />
                <div class="invalid-feedback" v-if="errors.has('company_id')">{{ errors.first('company_id') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{ $t('orgChartStructure.orgChartStructure') }}
              </label>
              <div>
                <ts-input
                  v-model="model.org_chart_structure"
                  :class="{ 'is-invalid': errors.has('org_chart_structure') }"
                />
                <div class="invalid-feedback" v-if="errors.has('org_chart_structure')">
                  {{ errors.first('org_chart_structure') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{ $t('orgChartStructure.levelCounter') }}
              </label>
              <div>
                <ts-select
                  v-model="model.level_counter"
                  :options="
                    orgChartLevelsByCompany(model.company_id).map(level => ({
                      value: level.org_id,
                      text: level.level_description
                    }))
                  "
                  :class="{ 'is-invalid': errors.has('level_counter') }"
                />
                <div class="invalid-feedback" v-if="errors.has('level_counter')">
                  {{ errors.first('level_counter') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">
                {{ $t('orgChartStructure.parentOrgChartStructure') }}
              </label>
              <div>
                <ts-select
                  v-model="model.parent_org_chart_structure_id"
                  :options="
                    orgChartParentStructuresByCompany(model.company_id)
                      .filter(s => (editData ? s.org_chart_structure_id != editData.org_chart_structure_id : true))
                      .map(s => ({
                        value: s.org_chart_structure_id,
                        text: s.org_chart_structure
                      }))
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">
              {{ $t('button.cancel') }}
            </ts-button>
            <ts-button
              outline
              color="primary"
              class="ml-2"
              :waiting="savingAndNew"
              @click.prevent="saveAndNew"
              v-if="editData === undefined"
              >{{ $t('button.createAndNew') }}</ts-button
            >
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">
              {{ editData ? $t('button.update') : $t('button.create') }}
            </ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { cloneDeep } from 'lodash'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'org-chart-structure-form',
  props: ['editData'],
  data() {
    const model = {
      company_id: this.editData ? this.editData.company_id : '',
      org_chart_structure: this.editData ? this.editData.org_chart_structure : '',
      level_counter: this.editData ? this.editData.level_counter : '',
      parent_org_chart_structure_id: this.editData ? this.editData.parent_org_chart_structure_id : ''
    }

    return {
      newModel: model,
      model: cloneDeep(model),
      errors: new Errors(),
      saving: false,
      savingAndNew: false
    }
  },
  computed: {
    ...mapState('hr/orgChartStructure', ['companies']),
    ...mapGetters('hr/orgChartStructure', ['orgChartLevelsByCompany', 'orgChartParentStructuresByCompany'])
  },
  methods: {
    submit() {
      let responseResult

      this.errors = new Errors()

      if (this.editData) {
        responseResult = this.$store.dispatch('hr/orgChartStructure/update', {
          id: this.editData.org_chart_structure_id,
          ...this.model
        })
      } else {
        responseResult = this.$store.dispatch('hr/orgChartStructure/create', this.model)
      }

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/orgChartStructure/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveAndNew() {
      this.savingAndNew = true

      this.submit()
        .then(() => {
          this.model = cloneDeep(this.newModel)
        })
        .finally(() => {
          this.savingAndNew = false
        })
    }
  }
}
</script>
